import { render, staticRenderFns } from "./villagesSite.vue?vue&type=template&id=6fcc3446&scoped=true&"
import script from "./villagesSite.vue?vue&type=script&lang=js&"
export * from "./villagesSite.vue?vue&type=script&lang=js&"
import style0 from "./villagesSite.vue?vue&type=style&index=0&id=6fcc3446&scoped=true&lang=less&"
import style1 from "./villagesSite.vue?vue&type=style&index=1&id=6fcc3446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcc3446",
  null
  
)

export default component.exports